import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Privacy } from './components/pages/privacy';
import { Layout } from './components/layout';
import Home from './components/pages/home';
import { ContactPage } from './components/pages/contact';
import PrivacyDagensOrd from './components/pages/privacy';
import V2Page from './components/pages/v2';

function App() {
  return (
    <Routes>
      <Route path="/" element={<V2Page />} />
      <Route path="/old" element={<Layout />}>
        <Route index element={<Home />}/>
        <Route path="privacy/dagensOrd" element={<PrivacyDagensOrd />}/>
        <Route path="privacy/" element={<Privacy />}/>
        <Route path="contact" element={<ContactPage />}/>
      </Route>
      <Route path="/v2" element={<V2Page />} />
    </Routes>
  );
}

export default App;
